<template>
  <label :for="`input-${inputId}`" class="form-label" v-if="showLabel">
    {{ label }}
  </label>
  <input v-bind="$attrs"
         class="form-control"
         :id="`input-${inputId}`"
         :value="modelValue"
         @input="emitValue($event)"
         :aria-label="label" />
  <div class="form-text" v-if="helperText">{{ helperText }}</div>
</template>

<script lang="ts">
  import { defineComponent } from 'vue';
  import { v4 as uuid } from 'uuid';

  export default defineComponent({
    name: 'TextInput',
    props: {
      helperText: {
        type: String,
        default: '',
      },
      label: {
        type: String,
        required: true,
      },
      modelValue: {
        type: [String, Number],
        default: '',
      },
      showLabel: {
        type: Boolean,
        default: true,
      },
    },
    setup(_, { emit }) {
      const inputId = uuid();

      // * Set to any type as Vue extends the Event object but there is no type
      const emitValue = (event: any) => {
        emit('update:modelValue', event.target ? event.target.value : '');
      };

      return { inputId, emitValue };
    },
  });
</script>

<style lang="scss" scoped></style>
